// extracted by css-extract-rspack-plugin
export default {"cls1":"RecommendationsCard-cls1_xxD","cls2":"RecommendationsCard-cls2_P0t RecommendationsCard-cls1_xxD","altLook":"RecommendationsCard-altLook_Bz6"};